'use client';

import _objectWithoutProperties from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
const _excluded = ["effect", "style"],
  _excluded2 = ["direction", "reverse"],
  _excluded3 = ["big", "direction", "reverse"],
  _excluded4 = ["direction", "reverse", "style"],
  _excluded5 = ["style"],
  _excluded6 = ["reverse"],
  _excluded7 = ["direction", "reverse", "style"],
  _excluded8 = ["direction", "reverse"],
  _excluded9 = ["direction", "reverse"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { keyframes, css, ClassNames } from '@emotion/react';
import { useMemo, Children, isValidElement } from 'react';
import { InView, useInView } from 'react-intersection-observer';
import { isFragment } from 'react-is';
const bounce = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from,\n  20%,\n  53%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 0, 0);\n  }\n\n  40%,\n  43% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -30px, 0) scaleY(1.1);\n  }\n\n  70% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -15px, 0) scaleY(1.05);\n  }\n\n  80% {\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 0, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, -4px, 0) scaleY(1.02);\n  }\n"])));
const flash = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from,\n  50%,\n  to {\n    opacity: 1;\n  }\n\n  25%,\n  75% {\n    opacity: 0;\n  }\n"])));
const headShake = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(0);\n  }\n\n  6.5% {\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n\n  18.5% {\n    transform: translateX(5px) rotateY(7deg);\n  }\n\n  31.5% {\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n\n  43.5% {\n    transform: translateX(2px) rotateY(3deg);\n  }\n\n  50% {\n    transform: translateX(0);\n  }\n"])));
const heartBeat = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n\n  14% {\n    transform: scale(1.3);\n  }\n\n  28% {\n    transform: scale(1);\n  }\n\n  42% {\n    transform: scale(1.3);\n  }\n\n  70% {\n    transform: scale(1);\n  }\n"])));
const jello = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  from,\n  11.1%,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  22.2% {\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n\n  33.3% {\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n\n  44.4% {\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n\n  55.5% {\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n\n  66.6% {\n    transform: skewX(-0.78125deg) skewY(-0.78125deg);\n  }\n\n  77.7% {\n    transform: skewX(0.390625deg) skewY(0.390625deg);\n  }\n\n  88.8% {\n    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\n  }\n"])));
const pulse = keyframes(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"])));
const rubberBand = keyframes(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  30% {\n    transform: scale3d(1.25, 0.75, 1);\n  }\n\n  40% {\n    transform: scale3d(0.75, 1.25, 1);\n  }\n\n  50% {\n    transform: scale3d(1.15, 0.85, 1);\n  }\n\n  65% {\n    transform: scale3d(0.95, 1.05, 1);\n  }\n\n  75% {\n    transform: scale3d(1.05, 0.95, 1);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"])));
const shake = keyframes(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n"])));
const shakeX = keyframes(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n"])));
const shakeY = keyframes(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(0, -10px, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(0, 10px, 0);\n  }\n"])));
const swing = keyframes(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  20% {\n    transform: rotate3d(0, 0, 1, 15deg);\n  }\n\n  40% {\n    transform: rotate3d(0, 0, 1, -10deg);\n  }\n\n  60% {\n    transform: rotate3d(0, 0, 1, 5deg);\n  }\n\n  80% {\n    transform: rotate3d(0, 0, 1, -5deg);\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n"])));
const tada = keyframes(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  10%,\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\n  }\n\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n  }\n\n  40%,\n  60%,\n  80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"])));
const wobble = keyframes(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n\n  30% {\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n\n  60% {\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeIn = keyframes(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
const fadeInBottomLeft = keyframes(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInBottomRight = keyframes(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInDown = keyframes(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInDownBig = keyframes(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInLeft = keyframes(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInLeftBig = keyframes(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInRight = keyframes(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInRightBig = keyframes(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInTopLeft = keyframes(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInTopRight = keyframes(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInUp = keyframes(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const fadeInUpBig = keyframes(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
function getAnimationCss(_ref) {
  let {
    duration = 1e3,
    delay = 0,
    timingFunction = "ease",
    keyframes = fadeInLeft,
    iterationCount = 1
  } = _ref;
  return css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n    animation-delay: ", "ms;\n    animation-name: ", ";\n    animation-direction: normal;\n    animation-fill-mode: both;\n    animation-iteration-count: ", ";\n\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  "])), duration, timingFunction, delay, keyframes, iterationCount);
}
function isNullable(a) {
  return a == void 0;
}
function isStringLike(value) {
  return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}
function matchIf(onTrue, onFalse) {
  return condition => condition ? onTrue() : onFalse();
}
function matchIfOrNull(onTrue) {
  return matchIf(onTrue, () => null);
}
function hideWhen(condition) {
  return matchIfOrNull(() => ({
    opacity: 0
  }))(condition);
}
const Reveal = props => {
  const {
    cascade = false,
    damping = 0.5,
    delay = 0,
    duration = 1e3,
    fraction = 0,
    keyframes = fadeInLeft,
    triggerOnce = false,
    className,
    style,
    childClassName,
    childStyle,
    children,
    onVisibilityChange
  } = props;
  const animationStyles = useMemo(() => getAnimationCss({
    keyframes,
    duration
  }), [duration, keyframes]);
  if (isNullable(children)) return null;
  if (isStringLike(children)) return /* @__PURE__ */jsx(TextReveal, _objectSpread(_objectSpread({}, props), {}, {
    animationStyles,
    children: String(children)
  }));
  if (isFragment(children)) return /* @__PURE__ */jsx(FragmentReveal, _objectSpread(_objectSpread({}, props), {}, {
    animationStyles
  }));
  return /* @__PURE__ */jsx(Fragment, {
    children: Children.map(children, (node, index) => {
      if (!isValidElement(node)) return null;
      const nodeDelay = delay + (cascade ? index * duration * damping : 0);
      switch (node.type) {
        case "ol":
        case "ul":
          return /* @__PURE__ */jsx(ClassNames, {
            children: _ref2 => {
              let {
                cx
              } = _ref2;
              return /* @__PURE__ */jsx(node.type, _objectSpread(_objectSpread({}, node.props), {}, {
                className: cx(className, node.props.className),
                style: Object.assign({}, style, node.props.style),
                children: /* @__PURE__ */jsx(Reveal, _objectSpread(_objectSpread({}, props), {}, {
                  children: node.props.children
                }))
              }));
            }
          });
        case "li":
          return /* @__PURE__ */jsx(InView, {
            threshold: fraction,
            triggerOnce,
            onChange: onVisibilityChange,
            children: _ref3 => {
              let {
                inView,
                ref
              } = _ref3;
              return /* @__PURE__ */jsx(ClassNames, {
                children: _ref4 => {
                  let {
                    cx
                  } = _ref4;
                  return /* @__PURE__ */jsx(node.type, _objectSpread(_objectSpread({}, node.props), {}, {
                    ref,
                    className: cx(childClassName, node.props.className),
                    css: matchIfOrNull(() => animationStyles)(inView),
                    style: Object.assign({}, childStyle, node.props.style, hideWhen(!inView), {
                      animationDelay: nodeDelay + "ms"
                    })
                  }));
                }
              });
            }
          });
        default:
          return /* @__PURE__ */jsx(InView, {
            threshold: fraction,
            triggerOnce,
            onChange: onVisibilityChange,
            children: _ref5 => {
              let {
                inView,
                ref
              } = _ref5;
              return /* @__PURE__ */jsx("div", {
                ref,
                className,
                css: matchIfOrNull(() => animationStyles)(inView),
                style: Object.assign({}, style, hideWhen(!inView), {
                  animationDelay: nodeDelay + "ms"
                }),
                children: /* @__PURE__ */jsx(ClassNames, {
                  children: _ref6 => {
                    let {
                      cx
                    } = _ref6;
                    return /* @__PURE__ */jsx(node.type, _objectSpread(_objectSpread({}, node.props), {}, {
                      className: cx(childClassName, node.props.className),
                      style: Object.assign({}, childStyle, node.props.style)
                    }));
                  }
                })
              });
            }
          });
      }
    })
  });
};
const textBaseStyles = {
  display: "inline-block",
  whiteSpace: "pre"
};
const TextReveal = props => {
  const {
    animationStyles,
    cascade = false,
    damping = 0.5,
    delay = 0,
    duration = 1e3,
    fraction = 0,
    triggerOnce = false,
    className,
    style,
    children,
    onVisibilityChange
  } = props;
  const {
    ref,
    inView
  } = useInView({
    triggerOnce,
    threshold: fraction,
    onChange: onVisibilityChange
  });
  return matchIf(() => /* @__PURE__ */jsx("div", {
    ref,
    className,
    style: Object.assign({}, style, textBaseStyles),
    children: children.split("").map((char, index) => /* @__PURE__ */jsx("span", {
      css: matchIfOrNull(() => animationStyles)(inView),
      style: {
        animationDelay: delay + index * duration * damping + "ms"
      },
      children: char
    }, index))
  }), () => /* @__PURE__ */jsx(FragmentReveal, _objectSpread(_objectSpread({}, props), {}, {
    children
  })))(cascade);
};
const FragmentReveal = props => {
  const {
    animationStyles,
    fraction = 0,
    triggerOnce = false,
    className,
    style,
    children,
    onVisibilityChange
  } = props;
  const {
    ref,
    inView
  } = useInView({
    triggerOnce,
    threshold: fraction,
    onChange: onVisibilityChange
  });
  return /* @__PURE__ */jsx("div", {
    ref,
    className,
    css: matchIfOrNull(() => animationStyles)(inView),
    style: Object.assign({}, style, hideWhen(!inView)),
    children
  });
};
function getStyles$7(effect) {
  switch (effect) {
    case "bounce":
      return [bounce, {
        transformOrigin: "center bottom"
      }];
    case "flash":
      return [flash];
    case "headShake":
      return [headShake, {
        animationTimingFunction: "ease-in-out"
      }];
    case "heartBeat":
      return [heartBeat, {
        animationTimingFunction: "ease-in-out"
      }];
    case "jello":
      return [jello, {
        transformOrigin: "center"
      }];
    case "pulse":
      return [pulse, {
        animationTimingFunction: "ease-in-out"
      }];
    case "rubberBand":
      return [rubberBand];
    case "shake":
      return [shake];
    case "shakeX":
      return [shakeX];
    case "shakeY":
      return [shakeY];
    case "swing":
      return [swing, {
        transformOrigin: "top center"
      }];
    case "tada":
      return [tada];
    case "wobble":
      return [wobble];
  }
}
const AttentionSeeker = props => {
  const {
      effect = "bounce",
      style
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [keyframes, animationCss] = useMemo(() => getStyles$7(effect), [effect]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes,
    style: Object.assign({}, style, animationCss)
  }, rest));
};
const bounceIn = keyframes(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  from,\n  20%,\n  40%,\n  60%,\n  80%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n"])));
const bounceInDown = keyframes(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0) scaleY(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0) scaleY(0.9);\n  }\n\n  75% {\n    transform: translate3d(0, -10px, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, 5px, 0) scaleY(0.985);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const bounceInLeft = keyframes(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0) scaleX(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0) scaleX(1);\n  }\n\n  75% {\n    transform: translate3d(-10px, 0, 0) scaleX(0.98);\n  }\n\n  90% {\n    transform: translate3d(5px, 0, 0) scaleX(0.995);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const bounceInRight = keyframes(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0) scaleX(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0) scaleX(1);\n  }\n\n  75% {\n    transform: translate3d(10px, 0, 0) scaleX(0.98);\n  }\n\n  90% {\n    transform: translate3d(-5px, 0, 0) scaleX(0.995);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const bounceInUp = keyframes(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0) scaleY(5);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  75% {\n    transform: translate3d(0, 10px, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, -5px, 0) scaleY(0.985);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const bounceOut = keyframes(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  50%,\n  55% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n"])));
const bounceOutDown = keyframes(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  20% {\n    transform: translate3d(0, 10px, 0) scaleY(0.985);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0) scaleY(3);\n  }\n"])));
const bounceOutLeft = keyframes(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0) scaleX(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0) scaleX(2);\n  }\n"])));
const bounceOutRight = keyframes(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0) scaleX(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0) scaleX(2);\n  }\n"])));
const bounceOutUp = keyframes(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  20% {\n    transform: translate3d(0, -10px, 0) scaleY(0.985);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0) scaleY(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0) scaleY(3);\n  }\n"])));
function getStyles$6(reverse, direction) {
  switch (direction) {
    case "down":
      return reverse ? bounceOutDown : bounceInDown;
    case "left":
      return reverse ? bounceOutLeft : bounceInLeft;
    case "right":
      return reverse ? bounceOutRight : bounceInRight;
    case "up":
      return reverse ? bounceOutUp : bounceInUp;
    default:
      return reverse ? bounceOut : bounceIn;
  }
}
const Bounce = props => {
  const {
      direction,
      reverse = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const keyframes = useMemo(() => getStyles$6(reverse, direction), [direction, reverse]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes
  }, rest));
};
const fadeOut = keyframes(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));
const fadeOutBottomLeft = keyframes(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 100%, 0);\n  }\n"])));
const fadeOutBottomRight = keyframes(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 100%, 0);\n  }\n"])));
const fadeOutDown = keyframes(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n"])));
const fadeOutDownBig = keyframes(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n"])));
const fadeOutLeft = keyframes(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n"])));
const fadeOutLeftBig = keyframes(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n"])));
const fadeOutRight = keyframes(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n"])));
const fadeOutRightBig = keyframes(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n"])));
const fadeOutTopLeft = keyframes(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, -100%, 0);\n  }\n"])));
const fadeOutTopRight = keyframes(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, -100%, 0);\n  }\n"])));
const fadeOutUp = keyframes(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n"])));
const fadeOutUpBig = keyframes(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n"])));
function getStyles$5(big, reverse, direction) {
  switch (direction) {
    case "bottom-left":
      return reverse ? fadeOutBottomLeft : fadeInBottomLeft;
    case "bottom-right":
      return reverse ? fadeOutBottomRight : fadeInBottomRight;
    case "down":
      return big ? reverse ? fadeOutDownBig : fadeInDownBig : reverse ? fadeOutDown : fadeInDown;
    case "left":
      return big ? reverse ? fadeOutLeftBig : fadeInLeftBig : reverse ? fadeOutLeft : fadeInLeft;
    case "right":
      return big ? reverse ? fadeOutRightBig : fadeInRightBig : reverse ? fadeOutRight : fadeInRight;
    case "top-left":
      return reverse ? fadeOutTopLeft : fadeInTopLeft;
    case "top-right":
      return reverse ? fadeOutTopRight : fadeInTopRight;
    case "up":
      return big ? reverse ? fadeOutUpBig : fadeInUpBig : reverse ? fadeOutUp : fadeInUp;
    default:
      return reverse ? fadeOut : fadeIn;
  }
}
const Fade = props => {
  const {
      big = false,
      direction,
      reverse = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  const keyframes = useMemo(() => getStyles$5(big, reverse, direction), [big, direction, reverse]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes
  }, rest));
};
const flip = keyframes(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);\n    animation-timing-function: ease-out;\n  }\n\n  40% {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -190deg);\n    animation-timing-function: ease-out;\n  }\n\n  50% {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -170deg);\n    animation-timing-function: ease-in;\n  }\n\n  80% {\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)\n      rotate3d(0, 1, 0, 0deg);\n    animation-timing-function: ease-in;\n  }\n\n  to {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\n    animation-timing-function: ease-in;\n  }\n"])));
const flipInX = keyframes(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n\n  to {\n    transform: perspective(400px);\n  }\n"])));
const flipInY = keyframes(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n  }\n\n  to {\n    transform: perspective(400px);\n  }\n"])));
const flipOutX = keyframes(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n"])));
const flipOutY = keyframes(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    opacity: 0;\n  }\n"])));
function getStyles$4(reverse, direction) {
  switch (direction) {
    case "horizontal":
      return reverse ? flipOutX : flipInX;
    case "vertical":
      return reverse ? flipOutY : flipInY;
    default:
      return flip;
  }
}
const animationCss$1 = {
  backfaceVisibility: "visible"
};
const Flip = props => {
  const {
      direction,
      reverse = false,
      style
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  const keyframes = useMemo(() => getStyles$4(reverse, direction), [direction, reverse]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes,
    style: Object.assign({}, style, animationCss$1)
  }, rest));
};
const hinge = keyframes(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  0% {\n    animation-timing-function: ease-in-out;\n  }\n\n  20%,\n  60% {\n    transform: rotate3d(0, 0, 1, 80deg);\n    animation-timing-function: ease-in-out;\n  }\n\n  40%,\n  80% {\n    transform: rotate3d(0, 0, 1, 60deg);\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n\n  to {\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n"])));
const jackInTheBox = keyframes(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale(0.1) rotate(30deg);\n    transform-origin: center bottom;\n  }\n\n  50% {\n    transform: rotate(-10deg);\n  }\n\n  70% {\n    transform: rotate(3deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"])));
const rollIn = keyframes(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const rollOut = keyframes(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n  }\n"])));
const animationCss = {
  transformOrigin: "top left"
};
const Hinge = props => {
  const {
      style
    } = props,
    rest = _objectWithoutProperties(props, _excluded5);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes: hinge,
    style: Object.assign({}, style, animationCss)
  }, rest));
};
const JackInTheBox = props => {
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes: jackInTheBox
  }, props));
};
function getStyles$3(reverse) {
  return reverse ? rollOut : rollIn;
}
const Roll = props => {
  const {
      reverse = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded6);
  const keyframes = useMemo(() => getStyles$3(reverse), [reverse]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes
  }, rest));
};
const rotateIn = keyframes(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));
const rotateInDownLeft = keyframes(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));
const rotateInDownRight = keyframes(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));
const rotateInUpLeft = keyframes(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));
const rotateInUpRight = keyframes(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));
const rotateOut = keyframes(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 200deg);\n    opacity: 0;\n  }\n"])));
const rotateOutDownLeft = keyframes(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n"])));
const rotateOutDownRight = keyframes(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n"])));
const rotateOutUpLeft = keyframes(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n"])));
const rotateOutUpRight = keyframes(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 90deg);\n    opacity: 0;\n  }\n"])));
function getStyles$2(reverse, direction) {
  switch (direction) {
    case "bottom-left":
      return reverse ? [rotateOutDownLeft, {
        transformOrigin: "left bottom"
      }] : [rotateInDownLeft, {
        transformOrigin: "left bottom"
      }];
    case "bottom-right":
      return reverse ? [rotateOutDownRight, {
        transformOrigin: "right bottom"
      }] : [rotateInDownRight, {
        transformOrigin: "right bottom"
      }];
    case "top-left":
      return reverse ? [rotateOutUpLeft, {
        transformOrigin: "left bottom"
      }] : [rotateInUpLeft, {
        transformOrigin: "left bottom"
      }];
    case "top-right":
      return reverse ? [rotateOutUpRight, {
        transformOrigin: "right bottom"
      }] : [rotateInUpRight, {
        transformOrigin: "right bottom"
      }];
    default:
      return reverse ? [rotateOut, {
        transformOrigin: "center"
      }] : [rotateIn, {
        transformOrigin: "center"
      }];
  }
}
const Rotate = props => {
  const {
      direction,
      reverse = false,
      style
    } = props,
    rest = _objectWithoutProperties(props, _excluded7);
  const [keyframes, animationCss] = useMemo(() => getStyles$2(reverse, direction), [direction, reverse]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes,
    style: Object.assign({}, style, animationCss)
  }, rest));
};
const slideInDown = keyframes(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const slideInLeft = keyframes(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const slideInRight = keyframes(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const slideInUp = keyframes(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));
const slideOutDown = keyframes(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 100%, 0);\n  }\n"])));
const slideOutLeft = keyframes(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(-100%, 0, 0);\n  }\n"])));
const slideOutRight = keyframes(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(100%, 0, 0);\n  }\n"])));
const slideOutUp = keyframes(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -100%, 0);\n  }\n"])));
function getStyles$1(reverse, direction) {
  switch (direction) {
    case "down":
      return reverse ? slideOutDown : slideInDown;
    case "right":
      return reverse ? slideOutRight : slideInRight;
    case "up":
      return reverse ? slideOutUp : slideInUp;
    case "left":
    default:
      return reverse ? slideOutLeft : slideInLeft;
  }
}
const Slide = props => {
  const {
      direction,
      reverse = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded8);
  const keyframes = useMemo(() => getStyles$1(reverse, direction), [direction, reverse]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes
  }, rest));
};
const zoomIn = keyframes(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n"])));
const zoomInDown = keyframes(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));
const zoomInLeft = keyframes(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));
const zoomInRight = keyframes(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));
const zoomInUp = keyframes(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));
const zoomOut = keyframes(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));
const zoomOutDown = keyframes(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));
const zoomOutLeft = keyframes(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n  }\n"])));
const zoomOutRight = keyframes(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n  }\n"])));
const zoomOutUp = keyframes(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));
function getStyles(reverse, direction) {
  switch (direction) {
    case "down":
      return reverse ? zoomOutDown : zoomInDown;
    case "left":
      return reverse ? zoomOutLeft : zoomInLeft;
    case "right":
      return reverse ? zoomOutRight : zoomInRight;
    case "up":
      return reverse ? zoomOutUp : zoomInUp;
    default:
      return reverse ? zoomOut : zoomIn;
  }
}
const Zoom = props => {
  const {
      direction,
      reverse = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded9);
  const keyframes = useMemo(() => getStyles(reverse, direction), [direction, reverse]);
  return /* @__PURE__ */jsx(Reveal, _objectSpread({
    keyframes
  }, rest));
};
export { AttentionSeeker, Bounce, Fade, Flip, Hinge, JackInTheBox, Reveal, Roll, Rotate, Slide, Zoom, Reveal as default };